<template>
  <div class="monitoring-wrap">
    <template-search-read
      :readApi="readApi"
      :reload="reload"
      @searchFilter="getSearchFilter"
    >
    </template-search-read>
  </div>
</template>

<script>
import { getLoginHistoryBaDashboard } from "@/api/loginHistory";

import TemplateSearchRead from "@/components/_template/SearchRead";

export default {
  name: "BaLoginHistoryDashboard",
  components: {
    TemplateSearchRead,
  },
  methods: {
    getSearchFilter(value) {
      this.searchFilter = value;
    },
  },
  data() {
    return {
      reload: 0,
      readApi: getLoginHistoryBaDashboard,
      searchFilter: {},
    };
  },
};
</script>

<style lang="scss" scoped>
</style>
